import { MasterDataService, StorageService } from '@nextgen-web-framework/core';
import { Config, CategoryType } from '@com.amway.commerce/webshop-configs-v1-prod/Schema';
import { AdvanceShareCodeResponse } from '../services';

const SHARECODE_ATTRIBUTES = 'sharecodeAttributes';

export const isRegistrationMandatory = () => {
  const webShopConfigs = MasterDataService.getMasterData<Config>('WebshopConfigs') as Config;
  const localstorage = StorageService.getLocalStorage();
  // Will use SharecodeService here once we create it - instead of local storage
  const sharecodeAttributes = localstorage.retrieve(SHARECODE_ATTRIBUTES) as AdvanceShareCodeResponse;
  if (sharecodeAttributes) {
    return webShopConfigs.mandatoryRegistration.includes(sharecodeAttributes.category as CategoryType);
  }
  return false;
};
